import { render, staticRenderFns } from "./BusinessMemberInfo.vue?vue&type=template&id=daa8a578&"
import script from "./BusinessMemberInfo.vue?vue&type=script&lang=js&"
export * from "./BusinessMemberInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports